"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMarkerOffset = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var vector_1 = require("../../../math/vector");
var drawable_1 = require("./drawable");
var label_drawable_1 = require("./label.drawable");
/**
 * MarkerOffset drawable has its position set dynamically using to the Base Marker's "offset" property.
 * Technically it has no (x,y) state since that is computed from the capture and the Base Marker.
 */
var CollectionModelDrawableMarkerOffset = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMarkerOffset, _super);
    function CollectionModelDrawableMarkerOffset(collectionModelDrawableState, id, labelId) {
        if (id === void 0) { id = CollectionModelDrawableMarkerOffset.DEFAULT_DRAWABLE_ID; }
        if (labelId === void 0) { labelId = CollectionModelDrawableMarkerOffset.DEFAULT_LABEL_ID; }
        var _this = _super.call(this, collectionModelDrawableState, id) || this;
        _this._labelId = labelId;
        return _this;
    }
    CollectionModelDrawableMarkerOffset.createWithLabel = function (drawableState, labelPoint) {
        var marker = new CollectionModelDrawableMarkerOffset(drawableState);
        if (!labelPoint) {
            labelPoint = {
                x: 0,
                y: marker.y
            };
        }
        var label = new label_drawable_1.CollectionModelDrawableLabel(drawableState, marker.labelId, labelPoint.x, labelPoint.y, marker.id);
        return { marker: marker, label: label };
    };
    CollectionModelDrawableMarkerOffset.isBaseOffset = function (t) {
        return t instanceof CollectionModelDrawableMarkerOffset;
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "labelId", {
        get: function () {
            return this._labelId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "label", {
        get: function () {
            return this.drawableState.getDrawable(this.labelId);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarkerOffset.prototype.getLabelConnectionPoint = function (options) {
        return {
            x: this.label.isOnLeftSide()
                ? this.x - options.draw.state.markerOffsetWidth // Left
                : this.x + options.draw.state.markerOffsetWidth, // Right
            y: this.y
        };
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "x", {
        get: function () {
            if (this.drawableState.capture == null) {
                return 0;
            }
            return this.drawableState.capture.resolution.width / 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "y", {
        get: function () {
            var _a;
            var base = this.drawableState.base;
            if (base == null || this.drawableState.capture == null) {
                return 0;
            }
            var baseXY = base.getVector();
            var moveAmount = new vector_1.Vector(0, (_a = base.offset) !== null && _a !== void 0 ? _a : 0);
            return this.drawableState.collection.state.getGeometry(this.captureId).movePoint(baseXY, moveAmount).y;
        },
        enumerable: false,
        configurable: true
    });
    // The offset marker position is relative to the Base marker,
    // so adjust the move location of the Base marker by applying a negative base offset.
    CollectionModelDrawableMarkerOffset.prototype.move = function (x, y) {
        var _a;
        if (!this.drawableState.base || this.drawableState.capture == null) {
            return;
        }
        var clickPoint = new vector_1.Vector(x, y);
        var offset = new vector_1.Vector(0, -1 * ((_a = this.drawableState.base.offset) !== null && _a !== void 0 ? _a : 0));
        var offsetY = this.drawableState.collection.state.getGeometry(this.captureId).movePoint(clickPoint, offset).y;
        this.drawableState.base.move(x, offsetY);
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "type", {
        get: function () {
            return core_api_1.MarkerType.BASE_OFFSET;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "isDeletable", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarkerOffset.prototype.remove = function () {
        _super.prototype.remove.call(this);
        // Remove this offset marker's label too, unless it has already been removed
        if (this.drawableState.hasDrawable(this.labelId)) {
            this.label.remove();
        }
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "isInsightMeasurement", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarkerOffset.prototype.isApprovableInsightDrawable = function () {
        return false;
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "isVisible", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarkerOffset.prototype.clone = function (newParentDrawableState) {
        if (!newParentDrawableState.hasDrawable(this.labelId)) {
            this.label.clone(newParentDrawableState);
        }
        return new CollectionModelDrawableMarkerOffset(newParentDrawableState, this.id, this._labelId);
    };
    CollectionModelDrawableMarkerOffset.prototype.equals = function (other) {
        return (other instanceof CollectionModelDrawableMarkerOffset
            && this._equals(other));
    };
    CollectionModelDrawableMarkerOffset.DEFAULT_DRAWABLE_ID = 'offset';
    CollectionModelDrawableMarkerOffset.DEFAULT_LABEL_ID = 'offset:label';
    return CollectionModelDrawableMarkerOffset;
}(drawable_1.MoveableDrawable));
exports.CollectionModelDrawableMarkerOffset = CollectionModelDrawableMarkerOffset;
//# sourceMappingURL=marker.offset.drawable.js.map